import { FC } from 'react'
import { PiCaretDownBold } from 'react-icons/pi'

interface AccordionCaretProps {
  rotate?: boolean
}

export const AccordionCaret: FC<AccordionCaretProps> = ({ rotate }) => (
  <PiCaretDownBold className={`h-5 w-5 transition-transform ${rotate ? 'rotate-180' : ''}`} />
)
